import { useAxiosRequest } from 'common/hooks';
import { useState, useEffect } from 'react';

export const useGetImageUrl = (imgId: string) => {
  const [imgUrl, setImgUrl] = useState<string | null>(null);
  const imgDownload = useAxiosRequest('');
  useEffect(() => {
    if (!imgId) return;
    imgDownload.apiAction({
      urlObjKey: 'GetImageBase64Async',
      params: { strImageId: imgId },
      cb: (resData) => {
        const formattedBase64 = resData.startsWith('data:')
          ? resData
          : `data:image/png;base64,${resData}`;
        if (
          resData &&
          (formattedBase64.startsWith('data:image') ||
            formattedBase64.startsWith('data:'))
        ) {
          setImgUrl(formattedBase64);
        } else {
          setImgUrl(null);
        }
      },
      onError: (error) => {
        console.error('Error fetching image:', error);
      },
    });
  }, [imgId]);

  return { imgUrl, isLoading: imgDownload.isLoading };
};
